var SponsorEvents = (function(window, document){

    function sponsoredBin(bin){
        var url = $("#labelRoot").val() + "/checkout/is_sponsored_bin";
        var headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        var body = "bin=" + encodeURIComponent(bin);

        return new Promise(function(resolve, reject) {
            var request = new XMLHttpRequest();
            request.open("POST", url, true);
            for(var key in headers) {
                request.setRequestHeader(key, headers[key]);
            }
            request.onload = function() {
                if (request.status >= 200 && request.status < 400) {
                    resolve(JSON.parse(request.responseText));
                } else {
                    reject(Error(request.statusText));
                }
            };

            request.onerror = function() {
                reject(Error("Network Error"));
            };

            request.send(body);
        });
    }

    return {
        sponsoredBin: sponsoredBin,
    };
})(window, document);